import React, { useEffect, useState } from "react";
import { BookOpen, GraduationCap } from "lucide-react";
import { api } from "../../lib/api";

const color = (p) => (p >= 4 ? "#22A860" : p >= 3 ? "#E9A400" : "#C24141");
const Prom = ({ v }) => <span className="inline-flex items-center justify-center min-w-[3.25rem] rounded-full px-2 py-0.5 text-xs font-extrabold text-white" style={{ background: color(v) }}>{v.toFixed(2)}</span>;

export const EvalReporte = () => {
  const [d, setD] = useState(null);
  const [mat, setMat] = useState("");
  useEffect(() => { api.get("/admin/campus/eval-reporte").then((r) => setD(r.data)).catch(() => setD({ clases: [], materias: [] })); }, []);
  if (!d) return null;
  const clases = mat ? d.clases.filter((c) => c.materia === mat) : d.clases;
  return (
    <div className="space-y-6 mt-6" data-testid="eval-reporte">
      <div className="bg-white rounded-2xl ring-1 ring-black/5 p-4 sm:p-6">
        <p className="font-extrabold text-[#0A1C30] flex items-center gap-2"><BookOpen className="w-5 h-5 text-[#7B3FBF]" /> Promedio por materia</p>
        <p className="text-sm text-[#6B7688] mt-1">Compara a los instructores que imparten cada materia (1 a 5).</p>
        {d.materias.length === 0 ? <p className="mt-4 text-sm text-[#6B7688]">Aún no hay evaluaciones.</p> : (
          <div className="mt-4 grid md:grid-cols-2 gap-3">
            {d.materias.map((m) => (
              <div key={m.materia} className="rounded-xl bg-[#F7F8FA] p-4" data-testid={`reporte-materia-${m.materia}`}>
                <div className="flex items-center justify-between gap-2"><p className="font-bold text-[#0A1C30] text-sm">{m.materia}</p><Prom v={m.promedio} /></div>
                <p className="text-xs text-[#6B7688] mt-0.5">{m.evaluaciones} evaluación(es)</p>
                <div className="mt-2 space-y-1">{m.instructores.map((i) => <div key={i.instructor} className="flex items-center justify-between text-xs"><span className="text-[#2A3446]">{i.instructor} <span className="text-[#9AA3B2]">({i.evaluaciones})</span></span><Prom v={i.promedio} /></div>)}</div>
              </div>
            ))}
          </div>
        )}
      </div>
      <div className="bg-white rounded-2xl ring-1 ring-black/5 p-4 sm:p-6">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <p className="font-extrabold text-[#0A1C30] flex items-center gap-2"><GraduationCap className="w-5 h-5 text-[var(--gold)]" /> Promedio por clase</p>
          <select data-testid="reporte-filtro-materia" value={mat} onChange={(e) => setMat(e.target.value)} className="rounded-lg ring-1 ring-black/10 px-3 py-2 text-sm bg-white">
            <option value="">Todas las materias</option>{d.materias.map((m) => <option key={m.materia} value={m.materia}>{m.materia}</option>)}
          </select>
        </div>
        {clases.length === 0 ? <p className="mt-4 text-sm text-[#6B7688]">Aún no hay evaluaciones.</p> : (
          <div className="mt-4 overflow-x-auto">
            <table className="w-full text-sm" data-testid="reporte-clases-table">
              <thead><tr className="text-left text-xs uppercase text-[#6B7688]">{["Clase", "Materia", "Instructor", "Fecha", "Evaluaciones", "Promedio"].map((h) => <th key={h} className="px-3 py-2 whitespace-nowrap">{h}</th>)}</tr></thead>
              <tbody className="divide-y divide-black/5">
                {clases.map((c) => (
                  <tr key={c.clase_id} data-testid={`reporte-clase-${c.clase_id}`}>
                    <td className="px-3 py-2 font-bold text-[#0A1C30]">{c.clase}{c.grupo ? <span className="text-xs text-[#9AA3B2]"> · Grupo {c.grupo}</span> : null}</td>
                    <td className="px-3 py-2 text-[#2A3446]">{c.materia}</td>
                    <td className="px-3 py-2 text-[#2A3446]">{c.instructor}</td>
                    <td className="px-3 py-2 text-[#6B7688] whitespace-nowrap">{c.fecha}</td>
                    <td className="px-3 py-2 text-[#2A3446]">{c.evaluaciones}</td>
                    <td className="px-3 py-2"><Prom v={c.promedio} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};
